import * as React from "react";
const SvgHorizontalSlider = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24" }, props),
    React.createElement("g", { stroke: "currentColor", strokeWidth: 1.5 },
        React.createElement("path", { d: "M1 12h6.5M16.5 12H23M10 12a2 2 0 1 0 4 0 2 2 0 1 0-4 0M8.5 4H23M2 4a2 2 0 1 0 4 0 2 2 0 1 0-4 0M1 20h14.5M18 20a2 2 0 1 0 4 0 2 2 0 1 0-4 0" }))));
export default SvgHorizontalSlider;
